import { ACCESS_PROFILE, TAQYIMEE_OFFICE_ADMIN, TAQYIMEE_OFFICE_VALUATOR, TAQYIMEE_USER, UPDATE_PROFILE_PIC } from "./roles";
import { UserSource } from "./source";
import { BaseProfile, IProfile } from "./profiles";
import { getUser } from "./index";

type RoleName = {
	englishName: string;
	arabicName: string;
};

export interface ITaqymeeProfile extends IProfile {
	nameEn: string;
	nameAr: string;
	userName?: string;
	emailAddress: string;
	phoneNumber?: string;
	profileId: number;
	participantId: number;
	profileTypeId: number;
	emiratesId: string;
	groupId: number;
	role: RoleName;
	roleId: number;
	companyId: number;
	evaluatorId: number;
	evaluatorNumber: number;
}

export class TaqymeeProfile extends BaseProfile implements ITaqymeeProfile {
	nameEn: string;
	nameAr: string;
	userName?: string;
	emailAddress: string;
	phoneNumber?: string;
	profileId: number;
	participantId: number;
	profileTypeId: number;
	emiratesId: string;
	groupId: number;
	role: RoleName;
	roleId: number;
	companyId: number;
	evaluatorId: number;
	evaluatorNumber: number;

	constructor( profile: ITaqymeeProfile ) {
		super( UserSource.TAQYIMEE, profile.participantId );
		this.participantId = profile.participantId;
		this.emailAddress = profile.emailAddress;
		this.emiratesId = profile.emiratesId;
		this.groupId = profile.groupId;
		this.nameAr = profile.nameAr;
		this.nameEn = profile.nameEn;
		this.phoneNumber = profile.phoneNumber ? profile.phoneNumber.replace( /[^\d]/g, "" ) : undefined;
		this.profileId = profile.profileId;
		this.profileTypeId = profile.profileTypeId;
		this.role = profile.role;
		this.roleId = profile.roleId;
		this.companyId = profile.companyId;
		this.evaluatorId = profile.evaluatorId;
		this.evaluatorNumber = profile.evaluatorNumber;
		this.refreshRoles();
	}

	static buildProfile( profile: ITaqymeeProfile ): ITaqymeeProfile {
		const p = new TaqymeeProfile( profile );
		return p;
	}

	static getProfile(): ITaqymeeProfile | undefined {
		const u = getUser();
		if ( u )
			return u.getProfile( UserSource.TAQYIMEE ) as TaqymeeProfile;
		return undefined;
	}

	static getParticipantId(): number | undefined {
		const p = TaqymeeProfile.getProfile();
		if ( p ) return p.participantId;
		return undefined;
	}

	static getEmiratesId(): string | undefined {
		const p = TaqymeeProfile.getProfile();
		if ( p ) return p.emiratesId;
		return undefined;
	}

	refreshRoles() {
		super.refreshRoles();
		if ( !this.hasRole( TAQYIMEE_USER ) ) this.addRole( TAQYIMEE_USER );
		if ( !this.hasRole( ACCESS_PROFILE ) ) this.addRole( ACCESS_PROFILE );
		if ( !this.hasRole( UPDATE_PROFILE_PIC ) ) this.addRole( UPDATE_PROFILE_PIC );
		if ( this.roleId === 1 ) {
			if ( !this.hasRole( TAQYIMEE_OFFICE_ADMIN ) ) this.addRole( TAQYIMEE_OFFICE_ADMIN );
		} else if ( this.roleId === 2 ) {
			if ( !this.hasRole( TAQYIMEE_OFFICE_VALUATOR ) ) this.addRole( TAQYIMEE_OFFICE_VALUATOR );
		}
	}
}
